<template>
    <div v-if="isShow" class="fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex justify-center items-center z-50 p-4"
        @click.self="closePopup()">
        <div class="bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl md:w-[450px] w-full max-h-[90vh] overflow-hidden border border-white/20 flex flex-col"
            :class="{ 'animate-popupFadeIn': isVisible, 'animate-popupFadeOut': !isVisible }">
            
            <!-- Header -->
            <div class="bg-brand text-yellow-500 py-3.5 px-5 font-bold text-[18px] flex items-center justify-between shadow-sm relative z-10">
                <div class="flex items-center gap-2">
                    <font-awesome-icon :icon="['fas', 'key']" /> Đổi mật khẩu
                </div>
                <button @click="closePopup()" class="w-8 h-8 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white/90 hover:bg-white hover:text-brand transition-colors focus:outline-none">
                    <font-awesome-icon :icon="['fas', 'xmark']" />
                </button>
            </div>

            <!-- Body items -->
            <div class="p-6 overflow-y-auto">
                <div class="space-y-4">
                    <div class="space-y-2">
                        <label class="text-sm font-medium text-gray-700">Mật khẩu cũ</label>
                        <div class="relative">
                            <input v-model="oldPassword" :type="showOldPassword ? 'text' : 'password'" placeholder="Nhập mật khẩu hiện tại" class="w-full px-4 py-2.5 rounded-xl border border-gray-300 focus:ring-2 focus:ring-brand focus:border-brand transition-colors pr-12" />
                            <div class="absolute inset-y-0 right-0 flex items-center pr-4 cursor-pointer text-gray-400 hover:text-gray-600" @click="showOldPassword = !showOldPassword">
                                <font-awesome-icon :icon="showOldPassword ? ['fas', 'eye-slash'] : ['fas', 'eye']" />
                            </div>
                        </div>
                    </div>
                    <div class="space-y-2">
                        <label class="text-sm font-medium text-gray-700">Mật khẩu mới</label>
                        <div class="relative">
                            <input v-model="newPassword" :type="showNewPassword ? 'text' : 'password'" placeholder="Nhập mật khẩu mới" class="w-full px-4 py-2.5 rounded-xl border border-gray-300 focus:ring-2 focus:ring-brand focus:border-brand transition-colors pr-12" />
                            <div class="absolute inset-y-0 right-0 flex items-center pr-4 cursor-pointer text-gray-400 hover:text-gray-600" @click="showNewPassword = !showNewPassword">
                                <font-awesome-icon :icon="showNewPassword ? ['fas', 'eye-slash'] : ['fas', 'eye']" />
                            </div>
                        </div>
                    </div>
                    <div class="space-y-2">
                        <label class="text-sm font-medium text-gray-700">Xác nhận mật khẩu mới</label>
                        <div class="relative">
                            <input v-model="confirmPassword" :type="showConfirmPassword ? 'text' : 'password'" placeholder="Nhập lại mật khẩu mới" class="w-full px-4 py-2.5 rounded-xl border border-gray-300 focus:ring-2 focus:ring-brand focus:border-brand transition-colors pr-12" @keyup.enter="changePassword" />
                            <div class="absolute inset-y-0 right-0 flex items-center pr-4 cursor-pointer text-gray-400 hover:text-gray-600" @click="showConfirmPassword = !showConfirmPassword">
                                <font-awesome-icon :icon="showConfirmPassword ? ['fas', 'eye-slash'] : ['fas', 'eye']" />
                            </div>
                        </div>
                    </div>
                </div>
                <p v-if="errorMsg" class="mt-4 text-red-500 text-sm">{{ errorMsg }}</p>
            </div>

            <!-- Footer -->
            <div class="p-5 bg-gray-50/80 border-t border-gray-100 flex items-center justify-end gap-3 rounded-b-2xl">
                <button
                    class="px-5 py-2.5 rounded-xl font-semibold border border-gray-300 text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors shadow-sm"
                    @click="closePopup()">Hủy</button>

                <button v-if="!isLoading"
                    class="px-6 py-2.5 rounded-xl font-bold bg-brand text-white shadow-[0_4px_10px_rgba(2,75,179,0.3)] hover:-translate-y-[1px] hover:bg-brand-light hover:shadow-[0_6px_14px_rgba(2,75,179,0.4)] transition-all flex items-center"
                    @click="changePassword()">Cập nhật <font-awesome-icon :icon="['fas', 'check']" class="ml-2" /></button>
                <button v-else disabled
                    class="px-6 py-2.5 rounded-xl font-bold bg-gray-400 text-white cursor-not-allowed flex items-center shadow-sm">
                    <svg class="mr-2 h-4 w-4 animate-spin" viewBox="0 0 24 24"><font-awesome-icon :icon="['fas', 'spinner']" /></svg> Đang xử lý...
                </button>
            </div>
            
        </div>
    </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL;

export default {
    props: {
        isShow: Boolean,
    },
    data() {
        return {
            isVisible: false,
            isLoading: false,
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            showOldPassword: false,
            showNewPassword: false,
            showConfirmPassword: false,
            errorMsg: ''
        };
    },
    watch: {
        isShow: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.isVisible = true;
                    this.oldPassword = '';
                    this.newPassword = '';
                    this.confirmPassword = '';
                    this.showOldPassword = false;
                    this.showNewPassword = false;
                    this.showConfirmPassword = false;
                    this.errorMsg = '';
                }
            }
        }
    },
    methods: {
        closePopup() {
            this.isVisible = false;
            setTimeout(() => {
                this.$emit('closed');
            }, 300);
        },
        async changePassword() {
            this.errorMsg = '';
            if (!this.oldPassword || !this.newPassword || !this.confirmPassword) {
                this.errorMsg = 'Vui lòng nhập đầy đủ thông tin';
                return;
            }
            if (this.newPassword !== this.confirmPassword) {
                this.errorMsg = 'Mật khẩu mới không khớp';
                return;
            }
            
            this.isLoading = true;
            try {
                const res = await this.$axios.post(`${API_URL}/authuserslog/change-password`, {
                    oldPassword: this.oldPassword,
                    newPassword: this.newPassword
                }, {
                    headers: {
                        'X-Authorization': `Bearer ${this.$app.userInfo.access_token}`
                    }
                });

                if (res.data.success) {
                    this.$notify.success({
                        title: 'Thành công',
                        message: res.data.message || 'Cập nhật mật khẩu thành công'
                    });
                    this.closePopup();
                } else {
                    this.errorMsg = res.data.message || 'Lỗi cập nhật mật khẩu';
                }
            } catch (err) {
                this.errorMsg = err.response?.data?.message || 'Có lỗi xảy ra, vui lòng thử lại';
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.animate-popupFadeIn {
    animation: popupFadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
.animate-popupFadeOut {
    animation: popupFadeOut 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes popupFadeIn {
    from {
        opacity: 0;
        transform: scale(0.95) translateY(-10px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}
@keyframes popupFadeOut {
    from {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
    to {
        opacity: 0;
        transform: scale(0.95) translateY(10px);
    }
}
</style>
